/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");


require('components/base/pop/pop');
require('components/base/btn/btn');
const tip = require('components/base/pop/tip');
const inputGroup = require('components/common/input-group/input-group');

const store = require('appVuex/store');
const ajaxHttp = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
require('appUtil/ajaxSetting');
require('rootPath/src/common/components/lib/filter.js');
const { setBreadCrumb } = require('src/common/vuex/action/common');

const template = require('./intelligent-sort.tpl');
require('./intelligent-sort.scss');

const intelligentSort = {
	template,
	store,
	vuex: {
    actions: {
     setBreadCrumb,
    },
    getters: {
      authorityBtnList(state){
        return state.authorityBtn.authorityBtnList;
      }
    }
  },
	data() {
		return {
      //接口地址
      sortUrl: apiPath.charge.sort,
      sortEditUrl: apiPath.charge.sortEdit,
      sortStartUrl: apiPath.charge.sortStart,
      evalUrl: apiPath.charge.evaluate,
      evalEditUrl: apiPath.charge.evaluateEdit,
      evalStartUrl: apiPath.charge.evaluateStart,
      evalLogUrl: apiPath.charge.evaluateLog,

			sortEdit: false,
      sortGrade: false,
      sortDisabled: true,
      spotItems: [
        {"value": 0, text: "站点类型权重",name: "typeWeight"},
        {"value": 0, text: "开放情况权重",name: "openWeight"},
        {"value": 0, text: "站点速率权重",name: "speedWeight"},
        {"value": 0, text: "站点车位权重",name: "parkingWeight"},
        {"value": 0, text: "站点点评权重",name: "commentWeight"},
        {"value": 0, text: "站点打分权重",name: "gradeWeight"}
      ],

      distanceItems: [
        {"value": 0, text: "距离范围",name: "distance"}
      ],
      distanceInfo: {
        "info1": "公里",
        "info2": "(该范围内的站点优先排列, 该范围以外的站点按照权重排列)"
      },

      gradeDisabled: true,
      spotTypeItems: [
        {text: "营运站点",name: "operator", value:0},
        {text: "个人站点",name: "personal", value:0},
        {text: "公共站点",name: "public", value:0}
      ],
      openSituationItems: [
        {text: "内部使用",name: "internal", value:0},
        {text: "预约使用",name: "order", value:0},
        {text: "对外开放",name: "opening", value:0}
      ],
      soptSpeedItems: [
        {text: "慢速",name: "slow", value:0},
        {text: "快速",name: "fast", value:0},
        {text: "超速",name: "ultrafast", value:0}
      ],
      parkNumItems: [
        {text: "1~3个",name: "rank1", value:0},
        {text: "4~8个",name: "rank2", value:0},
        {text: "9~20个",name: "rank3", value:0},
        {text: "21~50个",name: "rank4", value:0},
        {text: ">50个",name: "rank5", value:0}
      ],
      commentNumItems: [
        {text: "0条",name: "rank1", value:0},
        {text: "1~5条",name: "rank2", value:0},
        {text: "6~12条",name: "rank3", value:0},
        {text: "13~20条",name: "rank4", value:0},
        {text: "21~50条",name: "rank5", value:0},
        {text: ">50条",name: "rank6", value:0}
      ],
      spotGradeItems: [
        {text: "0分",name: "rank1", value:0},
        {text: "1.0~2.5分",name: "rank2", value:0},
        {text: "2.6~3.6分",name: "rank3", value:0},
        { text: "3.7~4.6分",name: "rank4", value:0},
        {text: "4.7~5.0分",name: "rank5", value:0}
      ],
      evaluateLog: [],
      sortID: "",
      evaluateID: "",
      remainingTimeInfo: "",

      tempSortObj: {},
      tempGradeObj: {},
      interval: null
		}
	},

	route: {
		data(transition) {
      transition.next();
    },
    waitForData: true
	},

	ready() {
    this.getEvaluateData();  //获取打分数据
    this.getSortData();      //获取排序数据
    this.getEvaluateLog();   //获取打分日志
	},

	methods: {
		editSort(){
      this.sortEdit = !this.sortEdit;
      this.sortDisabled = false;  //启用排序编辑
    },
    saveSort() {
      this.sortEdit = !this.sortEdit;

      let data = {};
      data = this.formatObj(this.$refs.spotItem.getData()); //6个维度打分策略的数据
      data["distance"] = this.$refs.distanceItem.getData()[0].value;
      data["sortID"] = this.sortID;
      
      ajaxHttp(this.sortEditUrl, {
        "type": "POST",
        "data": data
      }).then((res) => {

        if(res.code == 0){
          tip("保存成功");
          this.sortDisabled = true;  //禁用排序编辑

          this.sortID = res.data.sortID;
          this.getSortData();      //获取排序数据
        }
      }).catch((res) => {
        tip("保存失败");
        this.getSortData();
      });
    },
    canleSort() {
      this.sortEdit = !this.sortEdit;
      this.sortDisabled = true;  //禁用排序编辑

      this.getSortData();      //获取排序数据
    },
    // startSort() {
      // if (this.sortEditUrl){
        // tip("请先保存数据");
      // } else {
        // ajaxHttp(this.sortStartUrl, {
        //   "type": "POST",
        //   "data": {"sortID": this.sortID}
        // }).then((res) => {
        //   if(res.code == 0){
        //     tip("策略启用成功");
        //   }
        // // }).catch((res) => {
        //   // tip(res.messsage);
        // });
      // }
    // },

    editGrade() {
      this.sortGrade = !this.sortGrade;
      this.gradeDisabled = false;  //启用打分编辑
    },
    saveGrade() {
      this.sortGrade = !this.sortGrade;  

      let data = {};
      data.spotType = this.formatObj(this.$refs.spotType.getData()); //站点类型数据
      data.openSituation = this.formatObj(this.$refs.openSituation.getData()); //开放情况数据
      data.soptSpeed = this.formatObj(this.$refs.soptSpeed.getData());  //站点速率数据
      data.parkNum = this.formatObj(this.$refs.parkNum.getData());  //站点车位数据
      data.spotGrade = this.formatObj(this.$refs.spotGrade.getData());  //站点评分数据
      data.commentNum = this.formatObj(this.$refs.commentNum.getData());  //站点点评数据
      data.evaluateID = this.evaluateID;  //上一次打分的ID

      ajaxHttp(this.evalEditUrl, {
        "type": "POST",
        "data": data
      }).then((res) => {

        if(res.code == 0){
          tip("保存成功");
          this.gradeDisabled = true;   //禁用打分编辑

          this.evaluateID = res.data.evaluateID;
          this.getEvaluateData();  //获取打分数据
        }
      }).catch((res) => {
        tip("保存失败");
        this.getEvaluateData();
      });
    },
    canleGrade() {
      this.sortGrade = !this.sortGrade;  
      this.gradeDisabled = true;   //禁用打分编辑
      
      this.getEvaluateData();  //获取打分数据
    },
    startGrade() {
      if (this.sortGrade){
        tip("请先保存数据");
      } else {
        clearInterval(this.interval);  //清除定时器
        let token = window.localStorage.getItem('appBackToken');

        $.ajax({
          type: "POST",
          url: this.evalStartUrl,
          data: {"evaluateID": this.evaluateID},
          headers: { token: token },
          success:(res) => {
            this.$refs.doingGrade.hide(); 

            if(res.code === 0) {

              this.$refs.gradeSuccess.show();

              setTimeout(() => {
                this.$refs.gradeSuccess.hide()
              }, 1500);

              this.getEvaluateLog();   //获取打分日志
            } else if(res.code === 1) {

              // tip(res.error);
              let remainingTime = res.data.remainingTime;
              this.remainingTimeInfo = this.formatRemainingTime(remainingTime);

              this.interval = setInterval(() => {
                this.remainingTimeInfo = this.formatRemainingTime(remainingTime);
                remainingTime -= 1000;

                if (remainingTime <= 0){
                  clearInterval(this.interval);
                }
              }, 1000);
              this.$refs.remainingTime.show();
            } else if(res.code === 99) {
              tip(res.error)
            }
          },
          error:(res) => {
            this.$refs.doingGrade.hide(); 
            tip(res.error || '请求超时,请稍候在试');
          },
          beforeSend:(XHR) => {
            // 请求成功前, 打分正在进行
            this.$refs.doingGrade.show();
          }
        })
      }
    },
    //将获取的数组转为发送的对象形式
    formatObj(Arr) {
      let tempObj = {};

      for (var i of Arr) {
        tempObj[i.name] = parseInt(i.value);
      }
      return tempObj
    },
    formatRemainingTime(time) {
      //毫秒转为秒
      if (!isNaN(time) && /[0]{3}$/.test(time)) {
        time = Number(time) / 1000;
      }
      let _time = Number(time);
      let day = (_time/86400 >= 10 ? Math.floor(_time/86400) : `0${Math.floor(_time/86400)}`);
      _time -= day * 86400;
      let hours = (_time/3600 >= 10 ? Math.floor(_time/3600) : `0${Math.floor(_time/3600)}`);
      _time -= hours * 3600;
      let minutes = (_time/60 >= 10 ? Math.floor(_time/60) : `0${Math.floor(_time/60)}`);
      _time -= minutes * 60;
      let seconds = _time >= 10 ? _time : `0${_time}`;
      
      return `${day}天${hours}时${minutes}分${seconds}秒`
    },
    getEvaluateData() {

      ajaxHttp(this.evalUrl, {})
      .then((res) => {
        if(res.code == 0){
          let data = res.data;

          //打分策略项目分值赋值
          this.spotTypeItems = this.addPorpToObj(this.spotTypeItems, data.spotType);
          this.openSituationItems = this.addPorpToObj(this.openSituationItems, data.openSituation);
          this.soptSpeedItems = this.addPorpToObj(this.soptSpeedItems, data.soptSpeed);
          this.parkNumItems = this.addPorpToObj(this.parkNumItems, data.parkNum);
          this.commentNumItems = this.addPorpToObj(this.commentNumItems, data.commentNum);
          this.spotGradeItems = this.addPorpToObj(this.spotGradeItems, data.spotGrade);
           this.evaluateID = res.data.evaluateID; //打分的ID
        }
      }).catch((res) => {
        // tip(res.messsage);
      });
    },
    getSortData() {
      ajaxHttp(this.sortUrl, {})
      .then((res) => {

        if(res.code == 0){
          let data = res.data;
          this.sortID = res.data.sortID;

          //排序策略项目分值赋值
          this.spotItems = this.addPorpToObj(this.spotItems, data);
          this.distanceItems = this.addPorpToObj(this.distanceItems, data);
        }
      }).catch((res) => {
        // tip(res.messsage);
      });
    },
    //给本地对象添加新属性
    addPorpToObj(Obj, remoteObj) {
      let arr = [];

      for (let i of Obj) {
        let name = i.name;
        i["value"] = parseInt(`${remoteObj[name]}`);
        arr.push(i);
      }
      return arr;
    },
    getEvaluateLog() {
      let _this = this;

      ajaxHttp(this.evalLogUrl, {})
      .then((res) => {

        this.evaluateLog = res.data.logs;
      }).catch((res) => {
        // tip(res.messsage);
      });
    },
	},

	filters: {
    formatTime(time, hasNoHM) {
      let dTime = new Date(time),
          dMinutes = dTime.getMinutes();
          dMinutes = dMinutes< 10 ? "0"+ dMinutes : dMinutes;

      return ( hasNoHM ? `${dTime.getFullYear()}-${dTime.getMonth()+1}-${dTime.getDate()}  ${dTime.getHours()}:${dMinutes}` : `${dTime.getFullYear()}-${dTime.getMonth()+1}-${dTime.getDate()}`);
    },
    filterSpotNum(val) {
      return `打分站点数 : ${val}个`
    },
    reverse(val) {
      return val.reverse();  //数组反转
    }
	}
}

module.exports = intelligentSort;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/charge/intelligent-sort/intelligent-sort.js